import { useCallback } from 'react'
import Modal from '@components/modal/Modal'
import Form from '@components/form/FormWithContext'
import HiddenInput from '@components/form/context/HiddenInput'
import Textarea from '@components/form/context/Textarea'
import SubmitButton from '@components/form/context/SubmitButton'
import Icon from '@components/shared/Icon'
import useFormGenericPostHandler from '@hooks/useFormGenericPostHandler'
import useT from '@hooks/useTranslation'

const API = '/api/chat/new'

const messageInput = { t: ' ', name: 'message' }
const widthStyle = {maxWidth:'80vw',width:500}
const h2Style = {marginTop:0,...widthStyle}
const textareaStyle = {maxHeight:'70vh',height:300,...widthStyle}

const ContactForm = ({ user, from, to, topic, isOpen, onClose }) => {
    const onSubmit = useCallback(useFormGenericPostHandler(API, user, onClose),
        [from, to, topic])

    const text = {
        wpisz: useT('Wpisz wiadomość'),
        wyslij: useT('Wyślij')
    }

    return (
        <Modal open={isOpen} onClose={onClose}>
            <h2 style={h2Style}>{topic}</h2>
            <Form onSubmit={onSubmit}>
                <HiddenInput name="topic" defaultValue={topic} />
                <HiddenInput name="_to" defaultValue={to} />
                <Textarea {...messageInput}
                    placeholder={text.wpisz}
                    style={textareaStyle} />
                <br/>
                <SubmitButton style={{marginBottom:0}}>{text.wyslij} <Icon>send</Icon></SubmitButton>
            </Form>
        </Modal>
    )
}

export default ContactForm